import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { ConnectUserProfile, ConnectUserResponse } from '../models/connect-user.model';

@Injectable({
  providedIn: 'root'
})
export class ConnectUserService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = environment.connect2ApiBaseUrl;

  getCurrentUser() {
    return this.http.get<ConnectUserResponse>(`${this.apiBaseUrl}/user`).pipe(
      map((response): ConnectUserProfile => {
        const firstName = response.user.firstName?.trim() ?? '';
        const lastName = response.user.lastName?.trim() ?? '';
        const fullName = `${firstName} ${lastName}`.trim();

        return {
          displayName: fullName || response.user.userName?.trim() || response.user.email,
          organization: response.organization.name?.trim() || null,
          companyCode: response.organization.code?.trim() || null,
          sfUserGroup: response.user.sfUserGroup?.trim() || null
        };
      })
    );
  }

  getCurrentUserPicture() {
    return this.http.get(`${this.apiBaseUrl}/user/picture`, { responseType: 'blob' }).pipe(
      catchError((error) => {
        if (error.status === 404) {
          return of<Blob | null>(null);
        }

        return throwError(() => error);
      })
    );
  }
}